export class ProspectoCab {
    Alta_Usuario_Riesgo: string;
    Baja_Usuario: string;
    Correo_Comercial: string;
    Correo_Usuario_Riesgo: string;
    Estado: string;
    Estado_Prospecto_Desc: string;
    Estado_Prospecto_Det: string;
    Estado_Prospecto_Det_Desc: string;
    Fecha_Actualizacion?: string;
    Fecha_Registro: string;
    Fecha_Respuesta?: string;
    FlagAsignado?: boolean;
    Moneda: string;
    Moneda_Dsc: string;
    Monto_Comercial: number | string;
    Monto_Riesgo_Disponible?: number | string;
    Monto_Riesgo_Ejecutado?: number | string;
    Monto_Riesgo_Finalizado?: number | string;
    Monto_Riesgo_Inicial?: number | string;
    Nombre_Usuario_Comercial: string;
    Nombre_Usuario_Riesgo: string;
    Observaciones_Comercial: string;
    Observaciones_Riesgo: string;
    Razon_Social_Adq: string;
    Razon_Social_Prov: string;
    Ruc_Adquirente: string;
    Ruc_Proveedor: string;
    Sum_VNPP?: number | string;
    Tipo_Documento: string;
    Tipo_Documento_Desc: string;
    Usuario_Prospecto: string;
    idProspecto: number;
    idProspectoDet?: number;
    idPropuestaOperacion?: number;
    edit?: boolean;
    vnppTotal?: number | string;
    propuesta?: boolean;

    LineaAdmitida?: number;
    LineaUtilizada?: number;
    LineaDisponible?: number;
}